import React, {useRef, useState} from 'react';

import Clipboard from 'clipboard';
import {Tooltip} from 'reactstrap';
import {v4} from 'uuid';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {useSetTimeout} from 'app/utils/hooks';
import {gt} from 'app/utils/i18n';
import {getLocation} from 'app/utils/urls';

interface CopyTextButtonProps {
  disabled?: boolean;
  tooltip: string;
  text: string;
  className?: string;
  children: React.ReactNode;
}

export function CopyTextButton({
  disabled = false,
  tooltip,
  text,
  className = '',
  children,
}: CopyTextButtonProps): JSX.Element {
  const [showCopied, setCopied] = useState(false);
  const setCopiedTimeout = useSetTimeout();

  const buttonIdRef = useRef<string>(`copy-btn-${v4()}`);

  const handleClick = async () => {
    Clipboard.copy(text);
    setCopied(true);
    setCopiedTimeout(() => setCopied(false), 750);
  };

  return (
    <>
      <Tooltip isOpen={showCopied} target={buttonIdRef.current} placement="top">
        {gt('Copied!')}
      </Tooltip>

      <LazyTooltip hide={showCopied || disabled} tooltip={tooltip}>
        <button
          id={buttonIdRef.current}
          type="button"
          className={className}
          disabled={disabled}
          onClick={handleClick}
        >
          {children}
        </button>
      </LazyTooltip>
    </>
  );
}

interface CopyLinkButtonProps {
  disabled?: boolean;
  tooltip: string;
  link: string;
  className?: string;
  children?: React.ReactNode;
}
export function CopyLinkButton({
  disabled = false,
  tooltip,
  link,
  className = '',
  children,
}: CopyLinkButtonProps): JSX.Element {
  return (
    <CopyTextButton
      className={className}
      text={getLocation(link).href}
      tooltip={tooltip}
      disabled={disabled}
    >
      {children != null ? children : <i className="fa fa-link" />}
    </CopyTextButton>
  );
}
